import React from 'react'
import { createIcon } from '~/chakra'

export const DeviceTabletIcon = createIcon({
  displayName: 'DeviceTabletIcon',
  viewBox: '0 0 25 18',
  path: (
    <>
      <path
        d="M25 15.5V2.49998C25 1.122 23.8313-3e-8 22.3958-7e-8l-19.7916-5e-7C1.16875-6e-7 .00000182 1.122.00000172 2.49998L7.3e-7 15.5C6.3e-7 16.878 1.16875 18 2.60415 18H22.3958C23.8312 18 25 16.878 25 15.5ZM1.5625 9c0-.55102.46773-.99998 1.04165-.99998.57393 0 1.04165.44901 1.04165.99998s-.46772.99998-1.04165.99998c-.57392 0-1.04165-.44896-1.04165-.99998Zm3.125 7c-.2875 0-.52085-.224-.52085-.5V2.49998c0-.276.23335-.50001.52085-.50001h17.7083c.2875 0 .5209.22401.5209.50001V15.5c0 .276-.2334.5-.5209.5H4.6875Z"
        fill="currentColor"
      />
    </>
  ),
})
